<template>
    <div class="content mb-2" v-cloak>
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header data-background-color="green">
                        <div class="btn-toolbar justify-content-between mb-0">
                            <div>
                                <h4 class="title">{{ $t('registers.events.evaluation.tempRanking.confirmed') }}</h4>
                            </div>
                            <div>
                                <h4>
                                    <button v-if="expanded" class="btn btn-link m-0 p-0" @click.stop="sizeToggle">
                                        <i class="fas fa-compress-arrows-alt text-white"></i>
                                    </button>
                                    <button v-else class="btn btn-link m-0 p-0" @click.stop="sizeToggle">
                                        <i class="fas fa-expand-arrows-alt text-white"></i>
                                    </button>
                                </h4>
                            </div>
                        </div>

                        <p class="category">{{ $t('registers.events.evaluation.tempRanking.confirmedDetails') }}</p>
                    </md-card-header>
                    <md-card-content>
                        <div class="btn-toolbar justify-content-between mt-0 mb-2" role="toolbar">
                            <div class="form-inline"></div>

                            <div class="input-group">
                                <input v-model="confirmationListSearchQuery"
                                       v-on:keyup.enter.stop="massSearch"
                                       v-on:keyup.esc.stop="clearFilters"
                                       type="text"
                                       class="form-control"
                                       aria-label="Mass search input"
                                       aria-describedby="massSearch" />
                                <button class="btn btn-secondary" @click.stop="massSearch">
                                    <i class="fas fa-search"></i>
                                    {{ $t('buttons.search.btnText') }}
                                </button>
                                <button class="btn btn-secondary" @click.stop="clearFilters">
                                    <i class="fas fa-times"></i>
                                    {{ $t('buttons.clearFilters.btnText') }}
                                </button>
                            </div>
                        </div>

                        <kendo-datasource ref="confimationListDataSource"
                                          :transport="confimationListTransportSettings"
                                          :schema-model-id="'id'"
                                          :schema-model-fields="confimationListSchemaModel"
                                          :schema-total="'total'"
                                          :schema-data="'data'"
                                          :page-size="gridOptions.pageable.size"
                                          :server-paging="true"
                                          :server-sorting="true"
                                          :server-filtering="true"
                                          :error="dataSourceError"
                                          :requestEnd="datasorceRequestEnd"
                                          :filter="filter"></kendo-datasource>

                        <kendo-grid ref="confimationListGrid"
                                    :data-source-ref="'confimationListDataSource'"
                                    :pageable="gridOptions.pageable"
                                    :navigatable="gridOptions.navigatable"
                                    :editable="gridOptions.editable"
                                    :filterable="gridOptions.filterable"
                                    :reorderable="gridOptions.reorderable"
                                    :resizable="gridOptions.resizable"
                                    :groupable="gridOptions.groupable"
                                    :allow-copy="gridOptions.allowCopy"
                                    :column-menu="gridOptions.columnMenu"
                                    :sortable-mode="gridOptions.sortable.mode"
                                    :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                                    :sortable-show-indexes="gridOptions.sortable.showIndexes"
                                    :selectable="gridOptions.selectable"
                                    :scrollable="gridOptions.scrollable">
                            <kendo-grid-column :field="'id'" :filterable="true" :title="$t('registers.events.participants.gridHeaders.id')" :hidden="true"></kendo-grid-column>
                            <kendo-grid-column :field="'name'" :title="$t('registers.events.evaluation.tempRanking.eventName')"></kendo-grid-column>
                            <kendo-grid-column :field="'fullName'" :title="$t('registers.events.participants.gridHeaders.name')"></kendo-grid-column>
                            <kendo-grid-column :field="'position'" :title="$t('registers.events.participants.gridHeaders.position')" :hidden="isEnVersion"></kendo-grid-column>
                            <kendo-grid-column :field="'positionEn'" :title="$t('registers.events.participants.gridHeaders.position')" :hidden="!isEnVersion"></kendo-grid-column>
                            <kendo-grid-column :field="'institution'" :title="$t('registers.events.participants.gridHeaders.institutionNomenclature')" :hidden="isEnVersion"></kendo-grid-column>
                            <kendo-grid-column :field="'institutionEn'" :title="$t('registers.events.participants.gridHeaders.institutionNomenclature')" :hidden="!isEnVersion"></kendo-grid-column>
                            <kendo-grid-column :field="'time'" :format="'{0:dd.MM.yyyy HH:mm}'" :title="$t('registers.events.evaluation.tempRanking.confirmation.gridHeaders.time')"></kendo-grid-column>
                            <kendo-grid-column :field="'accommodationRequired'"
                                               :template="accommodationRequiredCellTemplate"
                                               :title="$t('participationConfirmation.accommodationRequired')">
                            </kendo-grid-column>
                        </kendo-grid>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
    import { Culture } from '../../../models/enums';
    import bus from '../../../components/sidemenu/event-bus';
    import { mapGetters } from 'vuex'

    export default {
        props: {
            registerEntityId: {
                type: Number,
                default: 0
            },
            confirmationExpanded: {
                type: Boolean,
                default: false
            }
        },
        components: {},
        data() {
            return {
                loading: false,
                expanded: this.confirmationExpanded,
                confirmationListSearchQuery: '',
                confimationListSchemaModel: {
                    id: { name: 'id', from: 'id', type: 'number', nullable: false },
                    fullName: {
                        name: 'fullName',
                        from: 'fullName',
                        type: 'string',
                        nullable: true
                    },
                    position: {
                        name: 'position',
                        from: 'position',
                        type: 'string',
                        nullable: true
                    },
                    positionEn: {
                        name: 'positionEn',
                        from: 'positionEn',
                        type: 'string',
                        nullable: true
                    },
                    institution: {
                        name: 'institution',
                        from: 'institution',
                        type: 'string',
                        nullable: true
                    },
                    institutionEn: {
                        name: 'institutionEn',
                        from: 'institutionEn',
                        type: 'string',
                        nullable: true
                    },
                    rank: {
                        name: 'rank',
                        from: 'rank',
                        type: 'number',
                        nullable: true
                    },
                    score: {
                        name: 'score',
                        from: 'score',
                        type: 'number',
                        nullable: true
                    },
                    time: {
                        name: 'time',
                        from: 'time',
                        type: 'date',
                        nullable: true
                    },
                    name: {
                        name: 'name',
                        from: 'name',
                        type: 'string',
                        nullable: true
                    },
                    accommodationRequired: {
                        name: 'accommodationRequired',
                        from: 'accommodationRequired',
                        type: 'boolean',
                        nullable: true
                    }
                },
                confimationListTransportSettings: {
                    read: {
                        url:
                            this.$store.getters.baseUrl +
                            `/api/tempRanking/tempRankingConfirmations`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            };
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration
                });
            },
            parameterMap(options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    return kendo.stringify(options);
                }
            },
            odata4ParameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    var newOptions = kendo.data.transports['odata-v4'].parameterMap(options, operation);

                    return newOptions;
                }
            },
            datasorceRequestEnd(e) {
                if (e.type === 'read' && e.response) {
                    let count = Number(e.response.count);
                    if (!isNaN(count)) {
                        this.$emit('rejectedCount', count);
                    }
                }
            },
            sizeToggle() {
                this.expanded = !this.expanded;
                this.$emit('sizeToggle')
            },
            clearFilters() {
                this.confirmationListSearchQuery = '';
                const grid = this.$refs.confimationListGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.confirmationListSearchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.confimationListGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.confirmationListSearchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            reload() {
                let grid = this.$refs.confimationListGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read()
                }
            },
            accommodationRequiredCellTemplate(dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.accommodationRequired ? 'badge-success' : 'badge-light') + '">' + kendo.htmlEncode(dataItem.accommodationRequired ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            onTemprankingConfirmed(eventName, personName, personNameEn) {
                this.reload();

                if (this.claims.event.read) {
                    this.$vs.notify({
                        title: this.$t('participationConfirmation.modalTitle'),
                        text: this.$t('participationConfirmation.notification', { eventName: eventName, personName: personName }),
                        color: 'primary',
                        time: this.$store.getters.notificationDuration
                    });
                }
            },
            onTemprankingRejected(eventName, personName, personNameEn) {
                this.reload();

                if (this.claims.event.read) {
                    this.$vs.notify({
                        title: this.$t('participationRejection.modalTitle'),
                        text: this.$t('participationRejection.notification', { eventName: eventName, personName: personName }),
                        color: 'primary',
                        time: this.$store.getters.notificationDuration
                    });
                }
            }
        },
        mounted() { },
        computed: {
            ...mapGetters(['claims', 'gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            isNew() {
                return isNaN(this.id) || this.id === undefined || this.id === 0;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            filter() {
                if (!this.registerEntityId && this.registerEntityId > 0) {
                    return {
                        logic: 'and',
                        filters: [
                            {
                                field: 'registerEntityId',
                                operator: 'eq',
                                value: this.registerEntityId
                            }
                        ]
                    };
                }

                return '';
            }
        },
        created() {
            this.bus = bus;

            this.bus.$on('tempranking-confirmed', this.onTemprankingConfirmed);
            this.bus.$on('tempranking-rejected', this.onTemprankingRejected);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.bus.$off('tempranking-confirmed', this.onTemprankingConfirmed);
            this.bus.$off('tempranking-rejected', this.onTemprankingRejected);
        },
    };
</script>

<style scoped>
</style>
